import React from "react";

import { NavItemInterface } from "../types/NavItemInterface";

const NavItem = ({ label, selected, onItemClicked }: NavItemInterface) => {
  let classes = selected ? "item selected" : "item";

  return (
    <li className={classes}>
      <div className="circle-container">
        <div className="circle" onClick={onItemClicked} />
      </div>
      <div className="label-container">
        <span className="label" onClick={onItemClicked}>
          {label}
        </span>
      </div>
    </li>
  );
};

export default NavItem;
